import * as React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import classnames from 'classnames'
import { ChipField } from 'react-admin'
import PropTypes from 'prop-types'

const useStyles = makeStyles({
  open: { backgroundColor: '#62d4ed' },
  working: { backgroundColor: '#4a8aab' },
  closed_converted: { backgroundColor: '#5cb85c' },
  closed_not_converted: { backgroundColor: '#d9534f' },
  cancelled: { backgroundColor: '#a0a0a0' },
})

const ColoredLeadPropertyStatusField = ({ record = {}, source = {} }) => {
  const classes = useStyles()
  const isOpened = (value) => value?.toLowerCase() === 'open'
  const isWorking = (value) => value?.toLowerCase() === 'working'
  const isCancelled = (value) => value?.toLowerCase() === 'cancelled'
  const isClosedConverted = (value) => value?.toLowerCase() === 'closed_converted'
  const isClosedNotConverted = (value) => value?.toLowerCase() === 'closed_not_converted'

  return (
    <ChipField
      size="small"
      className={classnames({
        [classes.open]: isOpened(record[source]),
        [classes.working]: isWorking(record[source]),
        [classes.closed_converted]: isClosedConverted(record[source]),
        [classes.closed_not_converted]: isClosedNotConverted(record[source]),
        [classes.cancelled]: isCancelled(record[source]),
      })}
      source={source}
    />
  )
}

ColoredLeadPropertyStatusField.propTypes = {
  record: PropTypes.object,
  source: PropTypes.object,
  props: PropTypes.object,
}

export default ColoredLeadPropertyStatusField
